export default "__VITE_ASSET__DxKUXiep__"